/* src/routes/$error.svelte generated by Svelte v3.31.0 */
import { SvelteComponent, init, safe_not_equal } from "../../web_modules/svelte/internal.js";

class $error extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, null, safe_not_equal, {});
	}
}

export default $error;
//# sourceMappingURL=$error.js.map
